import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReportInitialState } from "./reportModel";
import {
  getBandhaiPendingOrderReport,
  getDullPendingOrderReport,
  getGhatPendingOrderReport,
  getJadaiPendingOrderReport,
  getKarigarAmountLedgerReport,
  getKarigarPhineLedgerReport,
  getKarigarWiseBandhaiAmountPhineSummaryReport,
  getKarigarWiseDullAmountLedgerReport,
  getKarigarWiseGhatAmountPhineSummaryReport,
  getKarigarWiseJadaiAmountPhineSummaryReport,
  getKarigarWiseMinaAmountLedgerReport,
  getKarigarWisePalishAmountPhineSummaryReport,
  getMinaPendingOrderReport,
  getPalishPendingOrderReport,
  getStockReport,
} from "./services/reports.services";

const initialState: IReportInitialState = {
  loading: false,
  error: "",
  MinaPendingOrderReportList: [],
  MinaPendingOrderReportDetails: {
    from_date: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    to_date: new Date(),
    karigar_id: null,
  },
  DullPendingOrderReportList: [],
  DullPendingOrderReportDetails: {
    from_date: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    to_date: new Date(),
    karigar_id: null,
  },
  PalishPendingOrderReportList: [],
  PalishPendingOrderReportDetails: {
    from_date: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    to_date: new Date(),
    karigar_id: null,
  },
  GhatPendingOrderReportList: {
    PendingOrderList: [],
    PendingApprovalItem: [],
  },
  GhatPendingOrderReportDetails: {
    from_date: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    to_date: new Date(),
    karigar_id: null,
  },
  BandhaiPendingOrderReportList: {
    PendingOrderList: [],
    PendingApprovalItem: [],
  },
  BandhaiPendingOrderReportDetails: {
    from_date: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    to_date: new Date(),
    karigar_id: null,
  },
  JadaiPendingOrderReportList: {
    PendingOrderList: [],
    PendingApprovalItem: [],
  },
  JadaiPendingOrderReportDetails: {
    from_date: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    to_date: new Date(),
    karigar_id: null,
  },
  KarigarPhineLedgerReportList: [],
  KarigarPhineLedgerReportDetails: {
    from_date: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    to_date: new Date(),
    karigar_id: null,
  },
  KarigarAmountLedgerReportList: [],
  KarigarAmountLedgerReportDetails: {
    from_date: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    to_date: new Date(),
    karigar_id: null,
  },
  KarigarWiseGhatAmountPhineSummaryReportList: [],
  KarigarWiseGhatAmountPhineSummaryReportDetails: {
    from_date: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    to_date: new Date(),
    karigar_id: null,
  },
  KarigarWiseBandhaiAmountPhineSummaryReportList: [],
  KarigarWiseBandhaiAmountPhineSummaryReportDetails: {
    from_date: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    to_date: new Date(),
    karigar_id: null,
  },
  KarigarWisePalishAmountPhineSummaryReportList: [],
  KarigarWisePalishAmountPhineSummaryReportDetails: {
    from_date: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    to_date: new Date(),
    karigar_id: null,
  },
  KarigarWiseDullAmountLedgerReportList: [],
  KarigarWiseDullAmountLedgerReportDetails: {
    from_date: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    to_date: new Date(),
    karigar_id: null,
  },
  KarigarWiseMinaAmountLedgerReportList: [],
  KarigarWiseMinaAmountLedgerReportDetails: {
    from_date: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    to_date: new Date(),
    karigar_id: null,
  },
  KarigarWiseJadaiAmountPhineSummaryReportList: [],
  KarigarWiseJadaiAmountPhineSummaryReportDetails: {
    from_date: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    to_date: new Date(),
    karigar_id: null,
  },
  StockReportReportList: [],
  StockReportReportFilter: {
    ProductID: null,
    CategoryID: null,
    SubCategoryID: null,
  },
};

const reportSlice = createSlice({
  name: "reports",
  initialState,
  reducers: {
    setStockReportReportFilter: (state, action) => {
      state.StockReportReportFilter = action.payload;
    },
    clearStockReportReportFilter: (state) => {
      state.StockReportReportFilter = initialState.StockReportReportFilter;
    },
    clearStockReportReportList: (state) => {
      state.StockReportReportList = initialState.StockReportReportList;
    },
    setMinaPendingOrderReportDetails: (state, action) => {
      state.MinaPendingOrderReportDetails = action.payload;
    },
    clearMinaPendingOrderReportDetails: (state) => {
      state.MinaPendingOrderReportDetails =
        initialState.MinaPendingOrderReportDetails;
    },
    clearMinaPendingOrderReportList: (state) => {
      state.MinaPendingOrderReportList = [];
    },
    setDullPendingOrderReportDetails: (state, action) => {
      state.DullPendingOrderReportDetails = action.payload;
    },
    clearDullPendingOrderReportDetails: (state) => {
      state.DullPendingOrderReportDetails =
        initialState.DullPendingOrderReportDetails;
    },
    clearDullPendingOrderReportList: (state) => {
      state.DullPendingOrderReportList = [];
    },
    setPalishPendingOrderReportDetails: (state, action) => {
      state.PalishPendingOrderReportDetails = action.payload;
    },
    clearPalishPendingOrderReportDetails: (state) => {
      state.PalishPendingOrderReportDetails =
        initialState.PalishPendingOrderReportDetails;
    },
    clearPalishPendingOrderReportList: (state) => {
      state.PalishPendingOrderReportList = [];
    },
    setGhatPendingOrderReportDetails: (state, action) => {
      state.GhatPendingOrderReportDetails = action.payload;
    },
    clearGhatPendingOrderReportDetails: (state) => {
      state.GhatPendingOrderReportDetails =
        initialState.GhatPendingOrderReportDetails;
    },
    clearGhatPendingOrderReportList: (state) => {
      state.GhatPendingOrderReportList =
        initialState.GhatPendingOrderReportList;
    },
    setBandhaiPendingOrderReportDetails: (state, action) => {
      state.BandhaiPendingOrderReportDetails = action.payload;
    },
    clearBandhaiPendingOrderReportDetails: (state) => {
      state.BandhaiPendingOrderReportDetails =
        initialState.BandhaiPendingOrderReportDetails;
    },
    clearBandhaiPendingOrderReportList: (state) => {
      state.BandhaiPendingOrderReportList =
        initialState.BandhaiPendingOrderReportList;
    },
    setJadaiPendingOrderReportDetails: (state, action) => {
      state.JadaiPendingOrderReportDetails = action.payload;
    },
    clearJadaiPendingOrderReportDetails: (state) => {
      state.JadaiPendingOrderReportDetails =
        initialState.JadaiPendingOrderReportDetails;
    },
    clearJadaiPendingOrderReportList: (state) => {
      state.JadaiPendingOrderReportList =
        initialState.JadaiPendingOrderReportList;
    },

    setKarigarPhineLedgerReportDetails: (state, action) => {
      state.KarigarPhineLedgerReportDetails = action.payload;
    },
    clearKarigarPhineLedgerReportDetails: (state) => {
      state.KarigarPhineLedgerReportDetails =
        initialState.KarigarPhineLedgerReportDetails;
    },
    clearKarigarPhineLedgerReportList: (state) => {
      state.KarigarPhineLedgerReportList =
        initialState.KarigarPhineLedgerReportList;
    },
    setKarigarAmountLedgerReportDetails: (state, action) => {
      state.KarigarAmountLedgerReportDetails = action.payload;
    },
    clearKarigarAmountLedgerReportDetails: (state) => {
      state.KarigarAmountLedgerReportDetails =
        initialState.KarigarAmountLedgerReportDetails;
    },
    clearKarigarAmountLedgerReportList: (state) => {
      state.KarigarAmountLedgerReportList =
        initialState.KarigarAmountLedgerReportList;
    },
    setKarigarWiseGhatAmountPhineSummaryReportDetails: (state, action) => {
      state.KarigarWiseGhatAmountPhineSummaryReportDetails = action.payload;
    },
    clearKarigarWiseGhatAmountPhineSummaryReportList: (state) => {
      state.KarigarWiseGhatAmountPhineSummaryReportList =
        initialState.KarigarWiseGhatAmountPhineSummaryReportList;
    },
    clearKarigarWiseGhatAmountPhineSummaryReportDetails: (state) => {
      state.KarigarWiseGhatAmountPhineSummaryReportDetails =
        initialState.KarigarWiseGhatAmountPhineSummaryReportDetails;
    },
    setKarigarWiseBandhaiAmountPhineSummaryReportDetails: (state, action) => {
      state.KarigarWiseBandhaiAmountPhineSummaryReportDetails = action.payload;
    },
    clearKarigarWiseBandhaiAmountPhineSummaryReportList: (state) => {
      state.KarigarWiseBandhaiAmountPhineSummaryReportList =
        initialState.KarigarWiseBandhaiAmountPhineSummaryReportList;
    },
    clearKarigarWiseBandhaiAmountPhineSummaryReportDetails: (state) => {
      state.KarigarWiseBandhaiAmountPhineSummaryReportDetails =
        initialState.KarigarWiseBandhaiAmountPhineSummaryReportDetails;
    },
    setKarigarWisePalishAmountPhineSummaryReportDetails: (state, action) => {
      state.KarigarWiseBandhaiAmountPhineSummaryReportDetails = action.payload;
    },
    clearKarigarWisePalishAmountPhineSummaryReportList: (state) => {
      state.KarigarWisePalishAmountPhineSummaryReportList =
        initialState.KarigarWisePalishAmountPhineSummaryReportList;
    },
    clearKarigarWisePalishAmountPhineSummaryReportDetails: (state) => {
      state.KarigarWisePalishAmountPhineSummaryReportDetails =
        initialState.KarigarWisePalishAmountPhineSummaryReportDetails;
    },
    setKarigarWiseDullAmountLedgerReportDetails: (state, action) => {
      state.KarigarWiseDullAmountLedgerReportDetails = action.payload;
    },
    clearKarigarWiseDullAmountLedgerReportList: (state) => {
      state.KarigarWiseDullAmountLedgerReportList =
        initialState.KarigarWiseDullAmountLedgerReportList;
    },
    clearKarigarWiseDullAmountLedgerReportDetails: (state) => {
      state.KarigarWisePalishAmountPhineSummaryReportDetails =
        initialState.KarigarWiseDullAmountLedgerReportDetails;
    },
    setKarigarWiseMinaAmountLedgerReportDetails: (state, action) => {
      state.KarigarWiseMinaAmountLedgerReportDetails = action.payload;
    },
    clearKarigarWiseMinaAmountLedgerReportList: (state) => {
      state.KarigarWiseMinaAmountLedgerReportList =
        initialState.KarigarWiseMinaAmountLedgerReportList;
    },
    clearKarigarWiseMinaAmountLedgerReportDetails: (state) => {
      state.KarigarWisePalishAmountPhineSummaryReportDetails =
        initialState.KarigarWiseMinaAmountLedgerReportDetails;
    },
    setKarigarWiseJadaiAmountPhineSummaryReportDetails: (state, action) => {
      state.KarigarWiseJadaiAmountPhineSummaryReportDetails = action.payload;
    },
    clearKarigarWiseJadaiAmountPhineSummaryReportList: (state) => {
      state.KarigarWiseJadaiAmountPhineSummaryReportList =
        initialState.KarigarWiseJadaiAmountPhineSummaryReportList;
    },
    clearKarigarWiseJadaiAmountPhineSummaryReportDetails: (state) => {
      state.KarigarWiseJadaiAmountPhineSummaryReportDetails =
        initialState.KarigarWiseJadaiAmountPhineSummaryReportDetails;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getMinaPendingOrderReport.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getMinaPendingOrderReport.fulfilled,
      (state, action: PayloadAction<any[]>) => {
        state.loading = false;
        state.MinaPendingOrderReportList = action.payload || [];
      },
    );
    builder.addCase(getMinaPendingOrderReport.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.DullPendingOrderReportList = [];
    });
    builder.addCase(getDullPendingOrderReport.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getDullPendingOrderReport.fulfilled,
      (state, action: PayloadAction<any[]>) => {
        state.loading = false;
        state.DullPendingOrderReportList = action.payload || [];
      },
    );
    builder.addCase(getDullPendingOrderReport.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.DullPendingOrderReportList = [];
    });
    builder.addCase(getPalishPendingOrderReport.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getPalishPendingOrderReport.fulfilled,
      (state, action: PayloadAction<any[]>) => {
        state.loading = false;
        state.PalishPendingOrderReportList = action.payload || [];
      },
    );
    builder.addCase(getPalishPendingOrderReport.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.PalishPendingOrderReportList = [];
    });
    builder.addCase(getGhatPendingOrderReport.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getGhatPendingOrderReport.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.GhatPendingOrderReportList =
          action.payload || initialState.GhatPendingOrderReportList;
      },
    );
    builder.addCase(getGhatPendingOrderReport.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.GhatPendingOrderReportList =
        initialState.GhatPendingOrderReportList;
    });
    builder.addCase(getBandhaiPendingOrderReport.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getBandhaiPendingOrderReport.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.BandhaiPendingOrderReportList =
          action.payload || initialState.BandhaiPendingOrderReportList;
      },
    );
    builder.addCase(getBandhaiPendingOrderReport.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.BandhaiPendingOrderReportList =
        initialState.BandhaiPendingOrderReportList;
    });
    builder.addCase(getJadaiPendingOrderReport.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getJadaiPendingOrderReport.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.JadaiPendingOrderReportList =
          action.payload || initialState.JadaiPendingOrderReportList;
      },
    );
    builder.addCase(getJadaiPendingOrderReport.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.JadaiPendingOrderReportList =
        initialState.JadaiPendingOrderReportList;
    });
    builder.addCase(getKarigarPhineLedgerReport.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getKarigarPhineLedgerReport.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.KarigarPhineLedgerReportList =
          action.payload || initialState.KarigarPhineLedgerReportList;
      },
    );
    builder.addCase(getKarigarPhineLedgerReport.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.KarigarPhineLedgerReportList =
        initialState.KarigarPhineLedgerReportList;
    });
    builder.addCase(getKarigarAmountLedgerReport.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getKarigarAmountLedgerReport.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.KarigarAmountLedgerReportList =
          action.payload || initialState.KarigarAmountLedgerReportList;
      },
    );
    builder.addCase(getKarigarAmountLedgerReport.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.KarigarAmountLedgerReportList =
        initialState.KarigarAmountLedgerReportList;
    });
    builder.addCase(
      getKarigarWiseGhatAmountPhineSummaryReport.pending,
      (state) => {
        state.loading = true;
        state.error = "";
      },
    );
    builder.addCase(
      getKarigarWiseGhatAmountPhineSummaryReport.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.KarigarWiseGhatAmountPhineSummaryReportList =
          action.payload ||
          initialState.KarigarWiseGhatAmountPhineSummaryReportList;
      },
    );
    builder.addCase(
      getKarigarWiseGhatAmountPhineSummaryReport.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
        state.KarigarWiseGhatAmountPhineSummaryReportList =
          initialState.KarigarWiseGhatAmountPhineSummaryReportList;
      },
    );
    builder.addCase(
      getKarigarWiseBandhaiAmountPhineSummaryReport.pending,
      (state) => {
        state.loading = true;
        state.error = "";
      },
    );
    builder.addCase(
      getKarigarWiseBandhaiAmountPhineSummaryReport.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.KarigarWiseBandhaiAmountPhineSummaryReportList =
          action.payload ||
          initialState.KarigarWiseBandhaiAmountPhineSummaryReportList;
      },
    );
    builder.addCase(
      getKarigarWiseBandhaiAmountPhineSummaryReport.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
        state.KarigarWiseBandhaiAmountPhineSummaryReportList =
          initialState.KarigarWiseBandhaiAmountPhineSummaryReportList;
      },
    );
    builder.addCase(
      getKarigarWisePalishAmountPhineSummaryReport.pending,
      (state) => {
        state.loading = true;
        state.error = "";
      },
    );
    builder.addCase(
      getKarigarWisePalishAmountPhineSummaryReport.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.KarigarWisePalishAmountPhineSummaryReportList =
          action.payload ||
          initialState.KarigarWisePalishAmountPhineSummaryReportList;
      },
    );
    builder.addCase(
      getKarigarWisePalishAmountPhineSummaryReport.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
        state.KarigarWisePalishAmountPhineSummaryReportList =
          initialState.KarigarWisePalishAmountPhineSummaryReportList;
      },
    );
    builder.addCase(getKarigarWiseDullAmountLedgerReport.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getKarigarWiseDullAmountLedgerReport.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.KarigarWiseDullAmountLedgerReportList =
          action.payload || initialState.KarigarWiseDullAmountLedgerReportList;
      },
    );
    builder.addCase(
      getKarigarWiseDullAmountLedgerReport.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
        state.KarigarWiseDullAmountLedgerReportList =
          initialState.KarigarWiseDullAmountLedgerReportList;
      },
    );
    builder.addCase(getKarigarWiseMinaAmountLedgerReport.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getKarigarWiseMinaAmountLedgerReport.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.KarigarWiseMinaAmountLedgerReportList =
          action.payload || initialState.KarigarWiseMinaAmountLedgerReportList;
      },
    );
    builder.addCase(
      getKarigarWiseMinaAmountLedgerReport.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
        state.KarigarWiseMinaAmountLedgerReportList =
          initialState.KarigarWiseMinaAmountLedgerReportList;
      },
    );
    builder.addCase(
      getKarigarWiseJadaiAmountPhineSummaryReport.pending,
      (state) => {
        state.loading = true;
        state.error = "";
      },
    );
    builder.addCase(
      getKarigarWiseJadaiAmountPhineSummaryReport.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.KarigarWiseJadaiAmountPhineSummaryReportList =
          action.payload ||
          initialState.KarigarWiseJadaiAmountPhineSummaryReportList;
      },
    );
    builder.addCase(
      getKarigarWiseJadaiAmountPhineSummaryReport.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
        state.KarigarWiseJadaiAmountPhineSummaryReportList =
          initialState.KarigarWiseJadaiAmountPhineSummaryReportList;
      },
    );
    builder.addCase(getStockReport.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getStockReport.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.StockReportReportList =
          action.payload || initialState.StockReportReportList;
      },
    );
    builder.addCase(getStockReport.rejected, (state, action) => {
      state.loading = false;
      state.StockReportReportList = initialState.StockReportReportList;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  setStockReportReportFilter,
  clearStockReportReportFilter,
  clearStockReportReportList,
  setMinaPendingOrderReportDetails,
  clearMinaPendingOrderReportDetails,
  clearMinaPendingOrderReportList,
  clearDullPendingOrderReportDetails,
  clearDullPendingOrderReportList,
  setDullPendingOrderReportDetails,
  clearPalishPendingOrderReportDetails,
  clearPalishPendingOrderReportList,
  setPalishPendingOrderReportDetails,
  clearGhatPendingOrderReportDetails,
  clearGhatPendingOrderReportList,
  setGhatPendingOrderReportDetails,
  clearBandhaiPendingOrderReportDetails,
  clearBandhaiPendingOrderReportList,
  setBandhaiPendingOrderReportDetails,
  clearJadaiPendingOrderReportDetails,
  clearJadaiPendingOrderReportList,
  setJadaiPendingOrderReportDetails,
  clearKarigarPhineLedgerReportDetails,
  clearKarigarPhineLedgerReportList,
  setKarigarPhineLedgerReportDetails,
  clearKarigarAmountLedgerReportDetails,
  clearKarigarAmountLedgerReportList,
  setKarigarAmountLedgerReportDetails,
  setKarigarWiseGhatAmountPhineSummaryReportDetails,
  clearKarigarWiseGhatAmountPhineSummaryReportDetails,
  clearKarigarWiseGhatAmountPhineSummaryReportList,
  clearKarigarWiseBandhaiAmountPhineSummaryReportDetails,
  clearKarigarWiseBandhaiAmountPhineSummaryReportList,
  setKarigarWiseBandhaiAmountPhineSummaryReportDetails,
  clearKarigarWisePalishAmountPhineSummaryReportDetails,
  clearKarigarWisePalishAmountPhineSummaryReportList,
  setKarigarWisePalishAmountPhineSummaryReportDetails,
  clearKarigarWiseDullAmountLedgerReportDetails,
  clearKarigarWiseDullAmountLedgerReportList,
  setKarigarWiseDullAmountLedgerReportDetails,
  clearKarigarWiseMinaAmountLedgerReportDetails,
  clearKarigarWiseMinaAmountLedgerReportList,
  setKarigarWiseMinaAmountLedgerReportDetails,
  clearKarigarWiseJadaiAmountPhineSummaryReportDetails,
  clearKarigarWiseJadaiAmountPhineSummaryReportList,
  setKarigarWiseJadaiAmountPhineSummaryReportDetails,
} = reportSlice.actions;
export default reportSlice.reducer;
